import { type AxiosResponse } from 'axios'

import { type CustomAxiosConfig } from '@/types/axios'
import { type BookingVisitTime } from '@/types/Booking'

import armSecureAxios from './secure-base'

export const fetchBookingVisitTimes = async (config?: CustomAxiosConfig): Promise<AxiosResponse<BookingVisitTime[]>> => {
  return await armSecureAxios.get('/visit-times/all', { ...config })
}

const bookingVisitDatetimeArmService = {
  fetchBookingVisitTimes
}

export default bookingVisitDatetimeArmService
